import { Button, Tooltip } from "antd";
import { Input } from "antd";
import ErrorsToggle from "screens/adLibrary/adImport/adCompleteImportDrawer/adImportTable/adImportToolbar/ErrorsToggle";
import IssueList from "screens/adLibrary/adImport/adCompleteImportDrawer/adImportTable/adImportToolbar/IssueList";
import NoIssues from "screens/adLibrary/adImport/adCompleteImportDrawer/adImportTable/adImportToolbar/NoIssues";
import { useToggle } from "shared/hooks/useToggle";
import ColumnsOutlined from "shared/icons/ColumnsOutlined";
import { IAdIssue } from "shared/types/adLibrary";

const Search = Input.Search;

interface Props {
  issues: IAdIssue[];
  onSearch: (value: string) => void;
  searchValue: string;
  onDisplayColumn: () => void;
}

const InstantExperiencesImportToolbar = ({
  issues,
  onSearch,
  searchValue,
  onDisplayColumn,
}: Props) => {
  const [displayIssues, toggleDisplayIssues] = useToggle();
  const isError = (issue: IAdIssue) => issue.type === "error";
  const numberOfErrors = issues.filter(isError).length;

  return (
    <div>
      <div style={{ display: "flex", marginBottom: 12 }}>
        <Search
          allowClear={true}
          style={{ width: "100%", marginRight: 8 }}
          placeholder="Search"
          value={searchValue}
          onChange={value => onSearch(value.target.value)}
        />
        {numberOfErrors > 0 ? (
          <ErrorsToggle
            displayIssues={displayIssues}
            toggleDisplayIssues={toggleDisplayIssues}
            numberOfErrors={numberOfErrors}
          />
        ) : (
          <NoIssues />
        )}
        <Tooltip title={"Select columns to display"}>
          <Button icon={<ColumnsOutlined />} onClick={onDisplayColumn} />
        </Tooltip>
      </div>
      {issues.length > 0 && displayIssues && <IssueList issues={issues} />}
    </div>
  );
};

export default InstantExperiencesImportToolbar;
